export const typeProfil = {
  TYPE_1: 'Marche',
  TYPE_2: 'Déficience visuelle',
  TYPE_3: 'Déficience motrice',
  TYPE_4: 'Déficience auditive',
  TYPE_5: 'Déficience mentale'
};